import { useEffect } from "react";
import isEditable from "./isEditable.js";

export default function useTicketDetailKeyboard({ enabled, onResolve, onClose, onNext, onPrev, onFocusReply, onAIGenerate }) {
    useEffect(() => {
        if (!enabled) return;
        const handler = (e) => {
            if (e.metaKey || e.ctrlKey || e.altKey) return;
            if (e.key === "Enter") {
                if (isEditable(e.target)) return;
                e.preventDefault();
                if (e.shiftKey) onAIGenerate?.();
                else onFocusReply?.();
                return;
            }
            if (e.shiftKey) return;
            if (isEditable(e.target)) return;
            const k = e.key.toLowerCase();
            if (k === "h") { e.preventDefault(); onResolve?.(); }
            else if (k === "c") { e.preventDefault(); onClose?.(); }
            else if (k === "j") { e.preventDefault(); onNext?.(); }
            else if (k === "k") { e.preventDefault(); onPrev?.(); }
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [enabled, onResolve, onClose, onNext, onPrev, onFocusReply, onAIGenerate]);
}
